import { Spin } from "antd";
import React from "react";
import LinkUnLinkMenuWithStoresModal from "./LinkUnLinkMenuWithStoresModal";
import { useTranslation } from "react-i18next";
import AppInput from "components/ui/AppInput";

export default function CreateNewMenuModal({
  handleMenuNameChange,
  loading,
  stores,
  menus,
  selectedStores,
  setselectedStores,
  newMenuState,
}) {
  const { t } = useTranslation();
  return (
    <Spin spinning={loading}>
      <div className="modal">
        <div className="mb-3">
          <AppInput
            name="name"
            label={t("Menu Name")}
            placeholder={t("Enter menu name")}
            value={newMenuState?.name}
            onInput={handleMenuNameChange}
          />
        </div>
        <div className="mb-3">
          <AppInput
            name="description"
            label={t("Menu Description")}
            placeholder={t("Enter menu Description")}
            value={newMenuState?.description}
            onInput={handleMenuNameChange}
          />

        </div>
      </div>
      <LinkUnLinkMenuWithStoresModal
        stores={stores}
        menus={menus}
        selectedStores={selectedStores}
        setselectedStores={setselectedStores}
        loading={loading}
      />
    </Spin>
  );
}
